import { HeaderMenuItem, MultiLevelHeaderMenuItem } from "../types/theme.js";

export function createLabel(item: MultiLevelHeaderMenuItem | HeaderMenuItem) {
  if ("label" in item) {
    return item.label;
  }

  if ("link" in item) {
    return item.link ? item.link.title : "";
  }

  return "";
}
